import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const SkeletonTitleFirstLineMobile: StyleRule = () => ({
    marginTop: pxToRem(10),
    marginBottom: pxToRem(2),
});

export const SkeletonTitleSecondLineMobile: StyleRule = () => ({
    marginBottom: pxToRem(10),
});

export const SkeletonSubheadingFirstLineMobile: StyleRule = () => ({
    marginBottom: pxToRem(2),
});
